import React from 'react';
import {
  Image, ScrollView, Text, View,
} from 'react-native';
import {
  getImageByKey,
  img_and_1,
  img_and_enable_kbd,
  img_and_select_kbd,
  img_bank_back,
  img_bank_door, img_bank_main,
  img_bank_main_bg, img_bank_shield_color, img_bank_shield_mask,
  img_bank_stars,
  img_bank_stars_bg,
  img_ios_1,
  img_ios_2,
  img_onboarding_and_02_a,
  img_onboarding_ios_02_a,
  img_sprites, img_stickers_big, img_stickers_small,
} from '../utils/ImagesManagementUtils';
import {
  getMediumFont, getRegularFont, xlateText,
} from '../utils/Utils';
import { Android, iOS, keyboard_logo } from '../utils/DictionaryManagementUtils';
import ChatBubbles from '../components/SimulatorsComponents/AuxiliaryComponent/Images/ChatBubbles';
import MenuServicesLayout from '../components/menuLayout/MenuServicesLayout';

const Sim_Z02_development_configurations = ({
  globJSON,
  arrSnapshotRefs,
  hideDisplay,
}) => {
  const img_stub = getImageByKey(globJSON.configurations.services.menu.keyboard_logo, keyboard_logo);
  let isAnd = false;
  const { colors } = globJSON.configurations.theme;

  const stickers_b = globJSON.configurations.onboarding.promotion.onboarding_big_stickers.fUri === null
    || globJSON.configurations.onboarding.promotion.onboarding_big_stickers.fUri.length === 0
    ? img_stickers_big
    : { uri: globJSON.configurations.onboarding.promotion.onboarding_big_stickers.fUri };
  const stickers_s = globJSON.configurations.onboarding.promotion.onboarding_small_stickers.fUri === null
    || globJSON.configurations.onboarding.promotion.onboarding_small_stickers.fUri.length === 0
    ? img_stickers_small
    : { uri: globJSON.configurations.onboarding.promotion.onboarding_small_stickers.fUri };

  function keyboardBox() {
    return {
      width: isAnd ? 1160 : 948,
      height: isAnd ? 813 : 660,
      marginLeft: isAnd ? 140 : 99,
      marginTop: 18 + (isAnd ? 381 : 663),
      position: 'absolute',
      backgroundColor: colors.app_background_color,
      overflow: 'hidden',
    };
  }

  function chatSep() {
    return {
      width: isAnd ? 1160 : 948,
      height: 18,
      marginLeft: isAnd ? 140 : 99,
      marginTop: isAnd ? 381 : 663,
      position: 'absolute',
      backgroundColor: colors.primary_cta_color,
    };
  }

  function bankImage() {
    return {
      width: isAnd ? 1160 : 948,
      height: isAnd ? 1286 : 1051,
      marginLeft: isAnd ? 141 : 99,
      marginTop: isAnd ? 0 : 210,
      // marginTop:2*(isAnd?1:33),
      position: 'absolute',
    };
  }

  function bankStars() {
    return {
      width: isAnd ? 1160 : 948,
      height: isAnd ? 1286 : 1051,
      marginLeft: isAnd ? 141 : 99,
      marginTop: isAnd ? 19 : 220,
      // marginTop:2*(isAnd?3:57),
      position: 'absolute',
    };
  }

  function keyboardBoxSprites() {
    return {
      width: isAnd ? 1160 : 948,
      height: 18 + (isAnd ? 813 : 660),
      marginLeft: isAnd ? 140 : 99,
      marginTop: isAnd ? 381 : 663,
      position: 'absolute',
      backgroundColor: colors.app_background_color,
    };
  }

  function borderSep() {
    return {
      width: isAnd ? 1160 : 948,
      height: 6 * 26,
      marginLeft: isAnd ? 140 : 99,
      marginTop: 10 + (isAnd ? 381 : 663),
      position: 'absolute',
      backgroundColor: colors.light_elements_color,
    };
  }

  function spritesCircle() {
    return {
      width: 128,
      height: 128,
      borderRadius: 64,
      marginLeft: isAnd ? 164 : 124,
      marginTop: 23 + (isAnd ? 381 : 663),
      position: 'absolute',
      backgroundColor: '#fff',
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 * 2 },
      shadowOpacity: 0.22,
      shadowRadius: 2 * 12,
    };
  }

  function spritesBox() {
    return {
      width: isAnd ? 1174 : 954,
      height: isAnd ? 659 : 543,
      marginLeft: isAnd ? 136 : 98,
      marginTop: isAnd ? 555 : 804,
      position: 'absolute',
    };
  }

  function stickersBigBox() {
    return {
      width: isAnd ? 1130 : 940,
      height: isAnd ? 324 : 269,
      marginLeft: isAnd ? 160 : 100,
      marginTop: isAnd ? 650 : 892,
      position: 'absolute',
    };
  }

  function stickersSmallBox() {
    return {
      width: isAnd ? 1000 : 810,
      height: isAnd ? 100 : 81,
      marginLeft: isAnd ? 227 : 170,
      marginTop: isAnd ? 1094 : 1248,
      position: 'absolute',
    };
  }

  const renderStickers = (forAndroid, forRef) => {
    isAnd = forAndroid;

    return (
      <View
        style={{ width: isAnd ? 1440 : 1146, height: isAnd ? 1368 : 1446 }}
        ref={forRef}
      >
        <View
          style={{
            width: isAnd ? 1160 : 948,
            height: isAnd ? 1212 : 1296,
            marginLeft: isAnd ? 140 : 99,
            marginTop: isAnd ? 0 : 45,
            position: 'absolute',
            backgroundColor: colors.app_background_color,
          }}
        />
        <View style={keyboardBoxSprites()} />
        <View style={borderSep()} />
        <Image fadeDuration={0} style={spritesBox()} source={img_sprites} />
        <Image fadeDuration={0} style={stickersBigBox()} source={stickers_b} />
        <Image
          fadeDuration={0}
          style={stickersSmallBox()}
          source={stickers_s}
        />

        <View style={spritesCircle()}>
          <Image
            fadeDuration={0}
            resizeMode="stretch"
            style={{
              width: 128, height: 128, marginLeft: 1, marginTop: 0,
            }}
            source={img_stub}
          />
        </View>

        <Image
          fadeDuration={0}
          style={{
            width: isAnd ? 1440 : 1146,
            height: isAnd ? 1368 : 1446,
            marginLeft: 0,
            marginTop: 0,
            position: 'absolute',
          }}
          source={isAnd ? img_and_1 : img_ios_2}
        />
      </View>
    );
  };

  //= ====================================================================

  const renderBank = (forAndroid, forRef) => {
    isAnd = forAndroid;

    return (
      <View
        style={{ width: isAnd ? 1440 : 1146, height: isAnd ? 1368 : 1446 }}
        ref={forRef}
      >
        <View
          style={{
            width: isAnd ? 1160 : 948,
            height: isAnd ? 1212 : 1296,
            marginLeft: isAnd ? 140 : 99,
            marginTop: isAnd ? 0 : 45,
            position: 'absolute',
            backgroundColor: 'white',
          }}
        />

        <Image
          fadeDuration={0}
          style={[
            bankStars(),
            { tintColor: colors.pressed_cta_color },
          ]}
          source={img_bank_stars_bg}
        />
        <Image
          fadeDuration={0}
          style={[
            bankStars(),
            { tintColor: colors.cta_font_color },
          ]}
          source={img_bank_stars}
        />

        <Image
          fadeDuration={0}
          style={[
            bankImage(),
            { tintColor: colors.pressed_cta_color },
          ]}
          source={img_bank_back}
        />

        <Image
          fadeDuration={0}
          style={[
            bankImage(),
            { tintColor: colors.primary_cta_color },
          ]}
          source={img_bank_main_bg}
        />
        <Image fadeDuration={0} style={bankImage()} source={img_bank_door} />
        <Image fadeDuration={0} style={bankImage()} source={img_bank_main} />

        <Image
          fadeDuration={0}
          style={[
            bankImage(),
            { tintColor: colors.positive_color },
          ]}
          source={img_bank_shield_color}
        />
        <Image
          fadeDuration={0}
          style={bankImage()}
          source={img_bank_shield_mask}
        />

        <Image
          fadeDuration={0}
          style={{
            width: isAnd ? 1440 : 1146,
            height: isAnd ? 1368 : 1446,
            marginLeft: 0,
            marginTop: 0,
            position: 'absolute',
          }}
          source={isAnd ? img_and_1 : img_ios_2}
        />
      </View>
    );
  };

  //= ====================================================================

  const renderMenu = (forAndroid, forRef) => {
    isAnd = forAndroid;
    const simPlatform = isAnd ? Android : iOS;
    return (
      <View
        style={{ width: isAnd ? 1440 : 1146, height: isAnd ? 1368 : 1446 }}
        ref={forRef}
      >
        <View style={{ marginStart: isAnd ? 300 : 165, marginTop: isAnd ? 50 : 150 }}>
          <ChatBubbles
            simPlatform={simPlatform}
            backgroundColor={colors.app_background_color}
            ToptintColor={colors.disabled_cta_color}
            BottomtintColor={colors.primary_cta_color}
            multi={isAnd ? 5 : 6}
          />
        </View>

        {globJSON.configurations.onboarding.promotion.onboarding_screen_2_is_automatic || !globJSON.configurations.onboarding.promotion.menu_screenshot.fUri ? (
          <View style={keyboardBox()}>
            <MenuServicesLayout globJSON={globJSON} multi={isAnd ? 6 : 5} />
          </View>
        )
          : (
            <Image
              fadeDuration={0}
              style={keyboardBox()}
              source={globJSON.configurations.onboarding.promotion.menu_screenshot.fUri}
            />
          )}
        <Image
          fadeDuration={0}
          style={{
            width: isAnd ? 1440 : 1146,
            height: isAnd ? 1368 : 1446,
            marginLeft: 0,
            marginTop: 0,
            position: 'absolute',
          }}
          source={isAnd ? img_and_1 : img_ios_2}
        />

        <View style={chatSep()} />
      </View>
    );
  };

  function hotkeyLogoAnd() {
    return {
      width: 3 * 2 * 46 - 7,
      height: 3 * 2 * 46 - 9,
      marginLeft: 3 * 2 * 64 + 1,
      marginTop: 3 * 2 * 6 + 20,
      position: 'absolute',
    };
  }

  function hotkeyLogoIos() {
    return {
      width: 2.6 * 2 * 57,
      height: 2.6 * 2 * 57,
      marginLeft: 2.6 * 2 * 40 + 6,
      marginTop: 2.6 * 2 * 22 - 4,
      position: 'absolute',
    };
  }

  return (
    <ScrollView
      pagingEnabled={false}
    >
      <View style={{
        marginLeft: 0, marginTop: 0, height: hideDisplay && 0, overflow: 'hidden',
      }}
      >
        {/* ====== Android: ic_onboarding_typing_experience ====== */}
        <View
          style={{
            width: 1440,
            height: 1368,
            marginLeft: 0,
            marginTop: 10 /* position:'absolute' */,
          }}
          ref={arrSnapshotRefs[7]}
        >
          <Image
            fadeDuration={0}
            style={{
              width: 1440,
              height: 1368,
              marginLeft: 0,
              marginTop: 0,
              position: 'absolute',
            }}
            source={img_onboarding_and_02_a}
          />
          <Image
            fadeDuration={0}
            resizeMode="stretch"
            style={hotkeyLogoAnd()}
            source={img_stub}
          />
        </View>

        {/* ====== iOS: ic_onboarding_typing_experience ====== */}
        <View
          style={{
            width: 1248,
            height: 1476,
            marginLeft: 0,
            marginTop: 10 /* position:'absolute' */,
          }}
          ref={arrSnapshotRefs[8]}
        >
          <Image
            fadeDuration={0}
            style={{
              width: 1248,
              height: 1476,
              marginLeft: 0,
              marginTop: 0,
              position: 'absolute',
            }}
            source={img_onboarding_ios_02_a}
          />
          <Image
            fadeDuration={0}
            resizeMode="stretch"
            style={hotkeyLogoIos()}
            source={img_stub}
          />
        </View>

        {/* ====== And: ic_android_enable_keyboard ====== */}
        <View
          style={{
            width: 1080,
            height: 1052,
            marginLeft: 0,
            marginTop: 10 /* position:'absolute' */,
          }}
        >
          <View
            style={{ width: 1080, height: 1052 }}
            ref={arrSnapshotRefs[0]}
          >
            <Image
              fadeDuration={0}
              style={{
                width: 1080,
                height: 1052,
                marginLeft: 0,
                marginTop: 0,
                position: 'absolute',
              }}
              source={img_and_enable_kbd}
            />
            <View
              style={{
                width: 3 * 2 * 104,
                height: 3 * 2 * 20,
                marginLeft: 3 * 2 * 37,
                marginTop: 3 * 2 * 65 - 210,
                position: 'absolute',
                justifyContent: 'center',
              }}
            >
              <Text
                style={{
                  width: 3 * 2 * 104,
                  fontFamily: `${getMediumFont(globJSON, Android, true)}`,
                  fontSize: 3 * 2 * 9.3,
                  color: '#ffffff',
                }}
              >
                {xlateText(globJSON.configurations.onboarding.instructions.onboarding_titleBar, globJSON)}
              </Text>
            </View>
            <View
              style={{
                width: 3 * 2 * 104,
                height: 3 * 2 * 20,
                marginLeft: 3 * 2 * 37,
                marginTop: 3 * 2 * 65 + 6,
                position: 'absolute',
                justifyContent: 'center',
              }}
            >
              <Text
                style={{
                  width: 3 * 2 * 104,
                  fontFamily: `${getMediumFont(globJSON, Android, true)}`,
                  fontSize: 3 * 2 * 9.3,
                  color: '#010101',
                }}
              >
                {xlateText(globJSON.configurations.onboarding.instructions.bank_keyboard, globJSON)}
              </Text>
            </View>
            <View
              style={{
                width: 3 * 2 * 104,
                height: 3 * 2 * 20,
                marginLeft: 3 * 2 * 37,
                marginTop: 3 * 2 * 65 + 280,
                position: 'absolute',
                justifyContent: 'center',
              }}
            >
              <Text
                style={{
                  width: 3 * 2 * 104,
                  fontFamily: `${getMediumFont(globJSON, Android, true)}`,
                  fontSize: 3 * 2 * 9.3,
                  color: '#718096',
                }}
              >
                {xlateText(globJSON.configurations.onboarding.instructions.another_keyboard, globJSON)}
              </Text>
            </View>
          </View>
        </View>

        {/* ====== And: ic_android_select_keyboard ====== */}
        <View
          style={{
            width: 1080,
            height: 1014,
            marginTop: 10 /* position:'absolute' */,
          }}
        >
          <View
            style={{ width: 1080, height: 1014 }}
            ref={arrSnapshotRefs[1]}
          >
            <Image
              fadeDuration={0}
              style={{
                width: 1080,
                height: 1014,
                marginLeft: 0,
                marginTop: 0,
                position: 'absolute',
              }}
              source={img_and_select_kbd}
            />
            <View
              style={{
                width: 2 * 104,
                height: 3 * 2 * 20,
                marginLeft: 3 * 2 * 37,
                marginTop: 3 * 2 * 88 - 360,
                position: 'absolute',
                justifyContent: 'center',
              }}
            >
              <Text
                style={{
                  width: 3 * 2 * 104,
                  fontFamily: `${getMediumFont(globJSON, Android, true)}`,
                  fontSize: 3 * 2 * 9.3,
                  color: '#909090',
                }}
              >
                {xlateText(globJSON.configurations.onboarding.instructions.onboarding_titleBar, globJSON)}
              </Text>
            </View>
            <View
              style={{
                width: 2 * 104,
                height: 3 * 2 * 20,
                marginLeft: 3 * 2 * 37 - 60,
                marginTop: 3 * 2 * 88 - 100,
                position: 'absolute',
                justifyContent: 'center',
              }}
            >
              <Text
                style={{
                  color: '#001a2f',
                  lineSpacingExtra: 6,
                  width: 3 * 2 * 104,
                  fontFamily: `${getMediumFont(globJSON, Android, true)}`,
                  fontSize: 3 * 2 * 9.3,
                }}
              >
                {xlateText(globJSON.configurations.onboarding.instructions.select_keyboard, globJSON)}
              </Text>
            </View>
            <View
              style={{
                width: 2 * 104,
                height: 3 * 2 * 20,
                marginLeft: 3 * 2 * 37,
                marginTop: 3 * 2 * 88 - 9,
                position: 'absolute',
                justifyContent: 'center',
              }}
            >
              <Text
                style={{
                  width: 3 * 2 * 104,
                  fontFamily: `${getMediumFont(globJSON, Android, true)}`,
                  fontSize: 3 * 2 * 9.3,
                  color: '#010101',
                }}
              >
                {xlateText(globJSON.configurations.onboarding.instructions.bank_keyboard, globJSON)}
              </Text>
            </View>
            <View
              style={{
                width: 2 * 104,
                height: 3 * 2 * 20,
                marginLeft: 3 * 2 * 37,
                marginTop: 3 * 2 * 88 + 100,
                position: 'absolute',
                justifyContent: 'center',
              }}
            >
              <Text
                style={{
                  width: 3 * 2 * 104,
                  fontFamily: `${getMediumFont(globJSON, Android, true)}`,
                  fontSize: 3 * 2 * 9.3,
                  color: '#010101',
                }}
              >
                {xlateText(globJSON.configurations.onboarding.instructions.other_keyboards, globJSON)}
              </Text>
            </View>
          </View>
        </View>

        {/* ====== iOS: ic_ios_select_keyboard ====== */}
        <View
          fadeDuration={0}
          style={{
            width: 870,
            height: 720,
            marginLeft: 0,
            marginTop: 10 /* position:'absolute' */,
          }}
        >
          <View
            style={{ width: 870, height: 720 }}
            ref={arrSnapshotRefs[2]}
          >
            <Image
              fadeDuration={0}
              style={{
                width: 870,
                height: 720,
                marginLeft: 0,
                marginTop: 0,
                position: 'absolute',
              }}
              source={img_ios_1}
            />
            <View
              style={{
                width: 2.5 * 2 * 121,
                height: 2.5 * 2 * 14,
                marginLeft: 2.5 * 2 * 4,
                marginTop: 2.5 * 2 * 54 - 200,
                position: 'absolute',
                justifyContent: 'center',
              }}
            >
              <Text
                style={{
                  width: 2.5 * 2 * 121,
                  textAlign: 'center',
                  fontFamily: `${getRegularFont(globJSON, 'iOS', true)}`,
                  fontSize: 2.5 * 2 * 9.3,
                  color: '#000000',
                }}
              >
                {xlateText(globJSON.configurations.onboarding.instructions.other_keyboards, globJSON)}
              </Text>
            </View>
            <View
              style={{
                width: 2.5 * 2 * 121,
                height: 2.5 * 2 * 14,
                marginLeft: 2.5 * 2 * 4,
                marginTop: 2.5 * 2 * 54 - 40,
                position: 'absolute',
                justifyContent: 'center',
              }}
            >
              <Text
                style={{
                  width: 2.5 * 2 * 121,
                  textAlign: 'center',
                  fontFamily: `${getRegularFont(globJSON, 'iOS', true)}`,
                  fontSize: 2.5 * 2 * 9.3,
                  color: '#fff',
                }}
              >
                {xlateText(globJSON.configurations.onboarding.instructions.bank_keyboard, globJSON)}
              </Text>
            </View>
            <View
              style={{
                width: 2.5 * 2 * 121,
                height: 2.5 * 2 * 14,
                marginLeft: 2.5 * 2 * 4 + 370,
                marginTop: 2.5 * 2 * 54 + 120,
                position: 'absolute',
                justifyContent: 'center',
              }}
            >
              <Text
                style={{
                  width: 2.5 * 2 * 121,
                  textAlign: 'center',
                  fontFamily: `${getRegularFont(globJSON, 'iOS', true)}`,
                  fontSize: 2.5 * 2 * 7.1,
                  color: '#030303',
                }}
              >
                {xlateText(globJSON.configurations.onboarding.instructions.keyboard_button, globJSON)}
              </Text>
            </View>
          </View>
        </View>

        {/* ====== And: ic_onboarding_services ====== */}
        <View
          style={{
            width: 1440,
            height: 1368,
            marginLeft: 0,
            marginTop: 10 /* position:'absolute' */,
          }}
        >
          {renderMenu(true, arrSnapshotRefs[3])}
        </View>

        {/* ====== iOS: ic_onboarding_services ====== */}
        <View
          style={{
            width: 1146,
            height: 1446,
            marginLeft: 0,
            marginTop: 10 /* position:'absolute' */,
          }}
        >
          {renderMenu(false, arrSnapshotRefs[4])}
        </View>

        {/* ====== And: ic_onboarding_security & ic_onboarding_media ====== */}
        <View
          style={{
            width: 1440,
            height: 1368,
            marginLeft: 0,
            marginTop: 10 /* position:'absolute' */,
          }}
        >
          {globJSON.configurations.onboarding.promotion.onboarding_screen_3_is_security
            ? renderBank(true, arrSnapshotRefs[6])
            : renderStickers(true, arrSnapshotRefs[6])}
        </View>

        {/* ====== iOS: ic_onboarding_security & ic_onboarding_media ====== */}
        <View
          style={{
            width: 1146,
            height: 1446,
            marginLeft: 0,
            marginTop: 10 /* position:'absolute' */,
          }}
        >
          {globJSON.configurations.onboarding.promotion.onboarding_screen_3_is_security
            ? renderBank(false, arrSnapshotRefs[5])
            : renderStickers(false, arrSnapshotRefs[5])}
        </View>
      </View>
    </ScrollView>
  );
};

export default Sim_Z02_development_configurations;
